import moment from 'moment'

// PD-0003 Fase 4 - rotulos/formatadores compartilhados entre o ranking, o drill e a tela de organizacao.

export const FASE_LABELS: Record<FaseTenant, string> = {
  BASE_DE_TESTE: 'Base de teste',
  DEMONSTRACAO: 'Demonstração',
  EM_IMPLANTACAO: 'Em implantação',
  EM_FUNCIONAMENTO: 'Em funcionamento',
  STANDBY: 'Standby',
  INATIVO: 'Inativo',
}

export const FASE_OPTIONS = (Object.keys(FASE_LABELS) as FaseTenant[]).map(
  fase => ({ value: fase, label: FASE_LABELS[fase] })
)

// Carimbos vem com hora (yyyy-MM-dd HH:mm:ss); demais datas em yyyy-MM-dd.
export const formatDataHora = (valor: string | null): string => {
  if (!valor) return '—'
  const m = moment(valor, 'YYYY-MM-DD HH:mm:ss')
  return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : '—'
}

export const formatData = (valor: string | null): string => {
  if (!valor) return '—'
  const m = moment(valor, 'YYYY-MM-DD')
  return m.isValid() ? m.format('DD/MM/YYYY') : '—'
}

export const formatHealth = (valor: number | null): string => {
  if (valor === null || valor === undefined) return '—'
  return valor.toFixed(1).replace('.', ',')
}

export const formatTaxaFalha = (valor: number | null): string => {
  if (valor === null || valor === undefined) return '—'
  return `${(valor * 100).toFixed(1).replace('.', ',')}%`
}

// Delta percentual atual vs anterior. null quando nao ha base (anterior = 0).
export const calcularDelta = (
  atual: number,
  anterior: number
): number | null => {
  if (!anterior) return null
  return ((atual - anterior) / anterior) * 100
}

export const formatDelta = (delta: number | null): string => {
  if (delta === null) return ''
  let sinal = ''
  if (delta > 0) sinal = '▲'
  else if (delta < 0) sinal = '▼'
  return `${sinal} ${Math.abs(delta).toFixed(0)}%`
}
